import axios from "axios";
// import { BASE_URL } from '../../../src/global'
import toast from "react-hot-toast";

const NetworkClient = () => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };

  const service = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "https://param.edu/api/",
    timeout: 30000, // 30-second timeout to prevent hung connections
    headers,
  });

  const handleError = async (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        sessionStorage.removeItem("token");
        localStorage.removeItem("token");
      } else if (status === 403) {
        toast.error("Access forbidden");
      } else if (status === 400) {
        const message = error.response.data?.message || "Invalid request. Please check your input.";
        toast.error(typeof message === "string" ? message.slice(0, 100) : "Invalid request.");
      } else if (status >= 500) {
        toast.error("A server error occurred. Please try again later.");
      }
    } else if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
      toast.error("Request timed out. Please check your network connection.");
    } else if (!error.response) {
      toast.error("Network error. Please verify your connection.");
    }
    return Promise.reject(error);
  };

  const handleSuccess = async (response) => {
    return response;
  };

  service.interceptors.response.use(handleSuccess, handleError);

  service.interceptors.request.use(async (config) => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token && typeof token === "string") {
      // Sanitize token before attaching
      const sanitizedToken = token.replace(/[^a-zA-Z0-9._\-~+/=]/g, "").trim();
      if (sanitizedToken) {
        config.headers["Authorization"] = sanitizedToken.startsWith("Bearer ")
          ? sanitizedToken
          : `Bearer ${sanitizedToken}`;
      }
    }
    config.baseURL = process.env.REACT_APP_API_BASE_URL || "https://param.edu/api/";
    return config;
  });

  const get = async (path, headers) => {
    const response = await service.get(path, { headers });
    return response;
  };

  const patch = async (path, payload, headers) => {
    const response = await service.request({
      method: "PATCH",
      url: path,
      responseType: "json",
      data: payload,
      headers,
    });
    return response;
  };

  const post = async (path, payload, headers) => {
    const response = await service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: payload,
      headers,
    });
    return response;
  };

  const deleteRequest = async (path, payload, headers) => {
    const response = await service.request({
      method: "DELETE",
      url: path,
      responseType: "json",
      data: payload,
      headers,
    });
    return response;
  };

  const put = async (path, payload, headers) => {
    const response = await service.request({
      method: "PUT",
      url: path,
      responseType: "json",
      data: payload,
      headers,
    });
    return response;
  };

  return {
    get,
    patch,
    post,
    delete: deleteRequest,
    put,
  };
};

export default NetworkClient();
